module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mission-edit-form"
    }
  }, [_vm._l((_vm.kelasList), function(kelas) {
    return _c('v-card', {
      key: kelas,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-actions', [_c('v-list-item', {
      staticClass: "pa-0",
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-bold pb-2"
    }, [_vm._v("Kelas")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "value": kelas,
        "outlined": "",
        "disabled": "",
        "filled": ""
      }
    })], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.expanded[kelas] = !_vm.expanded[kelas]
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(_vm.expanded[kelas] ? "mdi-chevron-up" : "mdi-chevron-down"))])], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.expanded[kelas]),
        expression: "expanded[kelas]"
      }],
      staticClass: "mx-5"
    }, [_vm._l((_vm.missionsByClass[kelas]), function(mission, mIndex) {
      return _c('v-card', {
        key: mIndex,
        staticClass: "mb-5 pa-3",
        attrs: {
          "flat": ""
        }
      }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
        staticClass: "font-weight-bold pb-2"
      }, [_vm._v("Fitur")]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "value": mission.feature_name,
          "outlined": "",
          "filled": "",
          "disabled": ""
        }
      })], 1)], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
        attrs: {
          "label": "Daily",
          "disabled": !_vm.allowDaily(mission.id)
        },
        on: {
          "change": function($event) {
            return _vm.handleDailyChange(mission)
          }
        },
        model: {
          value: (mission.is_daily),
          callback: function($$v) {
            _vm.$set(mission, "is_daily", $$v)
          },
          expression: "mission.is_daily"
        }
      }), _vm._v(" "), (mission.is_daily) ? _c('v-row', {
        attrs: {
          "dense": ""
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Misi per hari",
          "outlined": ""
        },
        model: {
          value: (mission.daily_target),
          callback: function($$v) {
            _vm.$set(mission, "daily_target", $$v)
          },
          expression: "mission.daily_target"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Poin per hari",
          "outlined": ""
        },
        model: {
          value: (mission.poin_daily),
          callback: function($$v) {
            _vm.$set(mission, "poin_daily", $$v)
          },
          expression: "mission.poin_daily"
        }
      })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "mt-3"
      }, [_c('v-checkbox', {
        attrs: {
          "label": "Weekly"
        },
        on: {
          "change": function($event) {
            return _vm.handleWeeklyChange(mission)
          }
        },
        model: {
          value: (mission.is_weekly),
          callback: function($$v) {
            _vm.$set(mission, "is_weekly", $$v)
          },
          expression: "mission.is_weekly"
        }
      }), _vm._v(" "), (mission.is_weekly) ? _c('v-row', {
        attrs: {
          "dense": ""
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Minggu 1",
          "outlined": ""
        },
        model: {
          value: (mission.week_one_target),
          callback: function($$v) {
            _vm.$set(mission, "week_one_target", $$v)
          },
          expression: "mission.week_one_target"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Minggu 2",
          "outlined": ""
        },
        model: {
          value: (mission.week_two_target),
          callback: function($$v) {
            _vm.$set(mission, "week_two_target", $$v)
          },
          expression: "mission.week_two_target"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Minggu 3",
          "outlined": ""
        },
        model: {
          value: (mission.week_three_target),
          callback: function($$v) {
            _vm.$set(mission, "week_three_target", $$v)
          },
          expression: "mission.week_three_target"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "6"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Minggu 4",
          "outlined": ""
        },
        model: {
          value: (mission.week_four_target),
          callback: function($$v) {
            _vm.$set(mission, "week_four_target", $$v)
          },
          expression: "mission.week_four_target"
        }
      })], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12"
        }
      }, [_c('v-text-field', {
        attrs: {
          "label": "Poin per minggu",
          "outlined": ""
        },
        model: {
          value: (mission.poin_weekly),
          callback: function($$v) {
            _vm.$set(mission, "poin_weekly", $$v)
          },
          expression: "mission.poin_weekly"
        }
      })], 1)], 1) : _vm._e()], 1)], 1)
    }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.submit(kelas)
        }
      }
    }, [_vm._v("\n            Simpan Misi Kelas " + _vm._s(kelas) + "\n          ")])], 1)], 2)])], 1)
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2abdd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/MissionEditForm.vue
// module id = 968
// module chunks = 1